/** Customer-facing wording (conversation app only — not Admin). */
export const CUSTOMER_DIGITAL_ASSISTANT_LABEL = 'digital assistant';

/** Display name for the assistant persona; never the internal word "agent". */
export function customerAssistantDisplayName(name: string | null | undefined): string {
  const trimmed = (name || '').trim();
  if (trimmed) return trimmed;
  return 'Digital assistant';
}

export function customerAssistantLoadingStatus(): string {
  return 'Preparing your digital assistant…';
}

export function customerAssistantCardTitle(): string {
  return 'Your digital assistant';
}

export function customerSessionDurationNote(sessionMaxMinutes?: number | null): string {
  const minutes =
    typeof sessionMaxMinutes === 'number' && Number.isFinite(sessionMaxMinutes) && sessionMaxMinutes > 0
      ? Math.round(sessionMaxMinutes)
      : null;
  if (minutes) {
    return `When you are ready, plan for a focused conversation — most sessions comfortably fit within about ${minutes} minutes.`;
  }
  return 'Take the conversation at your own pace — you can end the session whenever you are finished.';
}
